import { z } from 'zod';
/**
 * Geo-Schemas (Customer-Map-Feature).
 *
 * - addressSuggest: Vorschläge für strukturierte Adresseingabe (Nominatim).
 * - zipToCity:      PLZ → Ort Plausi-Check.
 * - websiteExtract: Adresse + Kontaktdaten aus einer Firmen-Website parsen.
 */
// ---- Address Suggest ----------------------------------------------------
export const addressSuggestQuery = z.object({
    q: z.string().min(2).max(200),
    country: z.string().length(2).optional(),
    limit: z.coerce.number().int().positive().max(10).default(5),
});
// ---- ZIP → City ---------------------------------------------------------
export const zipToCityQuery = z.object({
    zip: z.string().regex(/^\d{4,5}$/),
});
// ---- Website Extract ----------------------------------------------------
export const websiteExtractRequest = z.object({
    url: z.string().min(1),
});
export const websiteExtractResponse = z.object({
    url: z.string(),
    source: z.enum(['json-ld', 'regex', 'meta']),
    confidence: z.enum(['high', 'medium', 'low']),
    street: z.string().nullable(),
    houseNumber: z.string().nullable(),
    zip: z.string().nullable(),
    city: z.string().nullable(),
    company: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
});
// ---- Routes Batch (Buero → N Projekte) ----------------------------------
const latLng = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
export const routesBatchRequest = z.object({
    from: latLng,
    // Ziele tragen eine eigene id (Projekt-ID), damit das Frontend das Ergebnis
    // ohne Index-Annahmen zuordnen kann. Cap = OSRM-Demo-Limit (100 inkl. Quelle).
    to: z
        .array(latLng.extend({ id: z.number().int().positive() }))
        .min(1)
        .max(99),
});
export const routeResult = z.object({
    id: z.number().int().positive(),
    // null, wenn OSRM fuer dieses Ziel keine Route fand.
    durationSec: z.number().nullable(),
    distanceMeters: z.number().nullable(),
});
export const routesBatchResponse = z.object({
    results: z.array(routeResult),
});
